export enum GetStartedListPosition {
    ListView,
    QuickOption,
    FlexPane,
}
